<div class="db-billing__wrapper">
    <div class="db-billing__header" *ngIf="!(!paymentMethods?.length && !loading && !paymentPaypal?.length && !userSubscription?.paypalEmail)">
        <div>
            <h3>{{'text_managePaymentTitlePaypal' | dbText}}</h3>
            <a class="ds-resizable ds-btn-purple-blue {{isMobile ? 'ds-btn-s' : 'ds-btn-m'}}"
               (click)="addPaymentMethod()"><span>{{'text_addPaymentMethod' | dbText }}</span></a>
        </div>
    </div>
  <div class="db-billing" [ngClass]="{'db-billing-no-payments': ((userSubscription?.isExpired || !loading) && !paymentMethods?.length && !paymentPaypal?.length)}">
    <div class="db-no-payment-method" *ngIf="(!paymentMethods?.length && !loading && !paymentPaypal?.length
  && !userSubscription.paypalEmail && userSubscription.paymentType !== 'paypal')">
      <img src="../../../assets/images/icons/empty_credit_cards.svg" alt="">
      <div class="db-no-payment-title"><span>Hi!</span></div>
      <div class="db-no-payment-desc"><span [innerHtml]="'text_noPaymentMethodDesc' | dbText"></span></div>
      <div>
          <button class="ds-btn-purple-blue" [class.ds-btn-disabled]="loadingStripe" (click)="addPaymentMethod()">
              @if (!loadingStripe) {
                  <span>{{'text_addPaymentMethod' | dbText}}</span>
              }
              @else {
                  <db-loading-circular-spinner></db-loading-circular-spinner>
              }
          </button>
      </div>
    </div>

    <div class="db-billing-body mt20" *ngIf="paymentMethods?.length">
      <db-payment-method-item *ngIf="userSubscription?.paymentType === 'card'" class="db-payment-method-billing-item active" [withShadow]="true" [default]="true" [paymentMethod]="defaultCardPaymentMethod" [userSubscription]="userSubscription" [userPaymentMethod]="userSubscription?.paymentType" (onSetDefault)="onActivePaymentMethodChange($event)" (onDelete)="deletePaymentMethod($event)" ></db-payment-method-item>
      <div class="db-billing-body-other" *ngIf="paymentMethods?.length > 1 || (userSubscription.paymentType !== 'card' && paymentMethods?.length == 1 && userSubscription &&(userSubscription.type === UserSubscriptionType.PREMIUM || userSubscription.type === UserSubscriptionType.ONE_PRODUCT || userSubscription.type === UserSubscriptionType.FREE))">
        <h3>{{'text_managePaymentTitleOther' | dbText}}</h3>
        <ng-container *ngFor="let paymentMethod of paymentMethods">
          <db-payment-method-item *ngIf="!paymentMethod?.active || (paymentMethod?.active &&  userSubscription && userSubscription.paymentType !== 'card' && (userSubscription.type === UserSubscriptionType.PREMIUM || userSubscription.type === UserSubscriptionType.ONE_PRODUCT || userSubscription.type === UserSubscriptionType.FREE))" class="db-payment-method-billing-item" [userPaymentMethod]="userSubscription?.paymentType" [withShadow]="true" [paymentMethod]="paymentMethod" (onSetDefault)="onActivePaymentMethodChange($event)" [userSubscription]="userSubscription" (onDelete)="deletePaymentMethod($event)"></db-payment-method-item>
        </ng-container>
      </div>


    </div>
    <db-loading-screen [ngClass]="{'hidden':!loading}"></db-loading-screen>
  </div>
</div>
